import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";

const PartOfferFooterSection = ({
    setRateModalOpen,
    setReportIssueModalOpen
}) => {
    return (
        <div style={styles.mainContainer}>
            <p style={styles.title}>
                Upravljanje narudžbinom
            </p>

            {/*Theese Buttons should have IconComponent prop, but they are missing in the sketch */}
            <div style={styles.buttonContainer}>
                <BaseButton
                    onClick={() => alert('clicked')}
                    text={"Prati narudzbinu"}
                    variant={ButtonVariantEnum.WHITE}
                />

                <BaseButton
                    onClick={() => setRateModalOpen(true)}
                    text={"Preuzeo sam deo"}
                    variant={ButtonVariantEnum.WHITE}
                />

                <BaseButton
                    onClick={() => setReportIssueModalOpen(true)}
                    text={"Prijavi problem"}
                    variant={ButtonVariantEnum.WHITE}
                />

            </div>
        </div>
    );
};

export default PartOfferFooterSection;

const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        gap: 20
    }
}